import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { Form, Space, Input } from 'antd';
// Descriptions
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import FormItem from '@/common/FormItem';
import TextArea from 'antd/lib/input/TextArea';
import { EditOutlined, SaveTwoTone } from '@ant-design/icons';

function ApproveModal({
  // fileList,
  setFileList,
  onFinish,
  loading,
  modalVisible,
  setModalVisible,
  all_file_data
}) {
  // const [approversign, setApproversign] = useState('');
  const [form] = Form.useForm();
  useEffect(() => {
    console.log('inside ApproveModal', all_file_data);
  }, [all_file_data]);
  // console.log('approve_loading', loading);
  console.log('envelope_data', all_file_data);
  const [isEditingAmount, setIsEditingAmount] = useState(false);
  const [amount, setAmount] = useState(all_file_data?.nfa_amount || '');
  const [amountError, setAmountError] = useState('');

  const reqAmount = parseFloat(all_file_data?.req_amnt || 0);

  // useEffect(() => {
  //   // console.log('inside ApproveModal', all_file_data);
  //   setAmount(all_file_data?.nfa_amount || '');
  // }, [all_file_data]);
  useEffect(() => {
    const backendAmount = parseFloat(all_file_data?.nfa_amount || 0);
    if (!isNaN(backendAmount)) {
      setAmount(backendAmount.toString());
    } else {
      setAmount('');
    }
  }, [all_file_data]);

  const toggleEditAmount = () => {
    setIsEditingAmount((prev) => !prev);
  };

  // const formatAmount = (value) =>
  //   value?.toString()?.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

  // const parseAmount = (value) =>
  //   parseFloat(value.toString().replace(/,/g, '') || '0');
  const parseAmount = (value) => {
    const parsed = parseFloat(value?.toString().replace(/,/g, '') || '0');
    return isNaN(parsed) ? 0 : parsed;
  };

  const handleAmountChange = (e) => {
    const input = e.target.value;
    const numericValue = parseAmount(input);

    if (!isNaN(numericValue) && numericValue > reqAmount) {
      setAmountError(`Amount should not exceed ${reqAmount}`);
    } else {
      setAmountError('');
    }

    setAmount(input);
  };

  const saveAmount = () => {
    const numericValue = parseAmount(amount);
    if (!isNaN(numericValue) && numericValue > reqAmount) {
      setAmountError(`Amount should not exceed ${reqAmount}`);
    } else {
      // setAmount(formatAmount(amount));
      setAmount(amount);
      setIsEditingAmount(false);
      setAmountError('');
    }
  };
  // const saveAmount = () => {
  //   if (amount?.toString().trim() === '') {
  //     form.setFieldsValue({ nfa_amount: null });
  //     setIsEditingAmount(false);
  //     setAmountError(null);
  //     return;
  //   }

  //   if (isNaN(parseFloat(amount))) {
  //     setAmountError('Please enter a valid number');
  //     return;
  //   }

  //   form.setFieldsValue({ nfa_amount: parseFloat(amount).toFixed(2) }); // sync to form
  //   setIsEditingAmount(false);
  //   setAmountError(null);
  // };

  const handleSubmit = () => {
    if (amountError) {
      return;
    }

    const values = form.getFieldsValue();
    const parsedAmount = parseAmount(amount);
    // const parsedAmount =
    //   amount?.toString().trim() === '' ? null : parseAmount(amount);
    onFinish({ ...values, nfa_amount: parsedAmount });
  };

  return (
    <CustomModal
      style={{ marginTop: '90px' }}
      visible={modalVisible === 'approved' ? true : false}
      className={styles.background}
      title={'Approve the document'}
      onCancel={() => {
        setModalVisible('');
        setFileList([]);
      }}
      /* width={'40%'} */
      footer={null}
    >
      {/* {all_file_data && (
        <Descriptions
          column={1}
          size="small"
          bordered
          style={{ marginBottom: '24px' }}
        >
          <Descriptions.Item label="Plant">
            {all_file_data?.plant_master?.name || 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="Department">
            {all_file_data?.department?.function_name || 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="NFA Amount">
            {all_file_data?.nfa_amount || 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="Title">
            {all_file_data?.title || 'N/A'}
          </Descriptions.Item>
        </Descriptions>
      )} */}

      <Form
        form={form}
        layout="vertical"
        className="ant-form ant-form-vertical"
        // onFinish={onFinish}
        onFinish={handleSubmit}
      >
        {/* <FormItem name="action" value="approved"></FormItem> */}
        {/* <h3 className={styles.background}>Are you sure you want to approve?</h3>
        <br /> */}
        {/* {amount ? ( */}
        {/* {parseFloat(amount || '0') !== 0 ? ( */}
        {(parseAmount(amount) > 0 || isEditingAmount) && (
          <FormItem label="Amount" name="nfa_amount">
            <div
              style={{
                backgroundColor: '#f9f9f9',
                padding: '10px 12px',
                borderRadius: '6px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                border: '1px solid #f0f0f0'
              }}
            >
              {isEditingAmount ? (
                <>
                  <Input
                    value={amount}
                    onChange={handleAmountChange}
                    // onChange={(e) => setAmount(e.target.value)}
                    // onBlur={() => setIsEditingAmount(false)}
                    onBlur={saveAmount}
                    // onBlur={() => {
                    //   setAmount(formatAmount(amount));
                    //   setIsEditingAmount(false);
                    // }}
                    autoFocus
                    bordered={false}
                    style={{ padding: '0 12px 0 0' }}
                  />
                  <SaveTwoTone
                    twoToneColor="#52c41a"
                    onClick={saveAmount}
                    style={{
                      fontSize: '16px',
                      cursor: 'pointer',
                      marginLeft: '8px'
                    }}
                    title="Save"
                  />
                </>
              ) : (
                <>
                  {/* <span>{amount ? formatAmount(amount) : 'N/A'}</span> */}
                  <span>{amount || 'N/A'}</span>
                  <EditOutlined
                    onClick={toggleEditAmount}
                    style={{ color: '#999', cursor: 'pointer' }}
                  />
                </>
              )}
            </div>
            {amountError && (
              <div style={{ color: 'red', marginTop: '4px' }}>
                {amountError}
              </div>
            )}
          </FormItem>
        )}
        <FormItem
          label="Comments"
          name="comments"
          rules={[
            {
              required: false,
              message: 'Please enter comments'
            }
          ]}
        >
          <TextArea
            style={{ width: '100%' }}
            placeholder="Please provide additional details or comments"
            rows={4}
            allowClear
          />
        </FormItem>
        <br />
        <FormItem className="text-right" style={{ marginBottom: '0px' }}>
          <Space>
            <CustomButton
              htmlType="button"
              onClick={() => {
                setModalVisible('');
                setFileList([]);
              }}
            >
              Cancel
            </CustomButton>
            <CustomButton
              type="primary1"
              htmlType="submit"
              loading={loading}
              className={styles.approvebutton}
            >
              Approve
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </CustomModal>
  );
}

export default ApproveModal;
